import { render, staticRenderFns } from "./Turn.vue?vue&type=template&id=9792fc10"
import script from "./Turn.vue?vue&type=script&lang=js"
export * from "./Turn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports